module.exports = __webpack_public_path__ + "static/media/21ECLAC7.1c7946a6.jpg";